<template>
  <div
    class="calcHeader"
    :class="{ 'calcHeader--scrolled': isScrolled }"
    menu-name="lang"
  >
    <button class="calcHeader__lang" @click="toggleLangDropdownMenu">
      <gl-svg-icon
        v-if="isShowLangDropdown && $root.breakpoint.name === 'phone'"
        icon="close"
        class="calcHeader__icon"
      />
      <span v-else class="flag" :class="`flag--${$i18n.locale}`" />
    </button>
    <transition name="dropdown">
      <base-header-lang-dropdown
        v-if="isShowLangDropdown"
        :current-lang="$i18n.locale"
        class="calcHeader__dropdown calcHeader__dropdown--right"
        @close="isShowLangDropdown = false"
      />
    </transition>
  </div>
</template>

<script>
import BaseHeaderLangDropdown from './common/BaseHeaderLangDropdown'
import GlSvgIcon from '@gl/GlSvgIcon'

export default {
  name: 'TheHeader',
  components: { GlSvgIcon, BaseHeaderLangDropdown },
  data() {
    return {
      isScrolled: false,
      isShowLangDropdown: false,
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 0
    },
    toggleLangDropdownMenu() {
      this.isShowLangDropdown = !this.isShowLangDropdown
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/flag';

.calcHeader {
  display: flex;
  padding: 12px 16px;
  position: fixed;
  width: 100%;
  text-align: center;
  top: 0;
  transition: background-color 0.3s;
  z-index: 100;

  @media (min-width: $breakpoint-md) {
    text-align: left;
  }

  &__dropdown {
    background-color: #fff;
    box-shadow: 0 0 30px rgba(52, 142, 200, 0.15);
    position: absolute;
    top: 50px;
    z-index: 1002;

    @media (max-width: $breakpoint-md - 1px) {
      bottom: 0;
      left: 0;
      overflow: auto;
      position: fixed;
      right: 0;
    }

    &--left {
      left: 0;
    }

    &--right {
      right: 0;
    }
  }

  &__lang {
    margin-left: auto;
    margin-right: 0;
  }

  &__icon {
    filter: invert(1);
  }

  &--scrolled {
    background-color: #fff;
  }
}
</style>
